<template>
  <div>
    <div class="VerifyNode1" :style="{ height: H2 }" v-show="flags">
      <div class="VerifyNode" :style="{ height: H }">
        <div class="VerifyNode_All" id="Verify">
          <div class="VerifyNode-Top">
            <span>Verify Node Information</span
            ><span @click="none"
              ><img src="@/assets/pc/BkHash/close2.svg" alt=""
            /></span>
          </div>
          <div class="VerifyNode-center">
            <p>Nick Name</p>
            <p>Address</p>
            <p>Age</p>
          </div>
          <div class="VerifyNode-List">
            <ul>
              <li v-for="(item, index) in latestTranstion" :key="index" class="notranslate">
                <p>
                  <span><img :src="item.logo" alt="" /></span
                  ><span>{{ item.name }}</span>
                </p>
                <p @click="ToAddress(item.address)">
                  <span>{{ Address[index] }}</span>
                </p>
                <p>{{ item.tradeTime }}</p>
              </li>
            </ul>
          </div>
          <div>
            <Pagination
              @PaginationChanage="CurrentChange($event)"
              :Total="total"
              :BiaoSi="biaoshi"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { goPAGE,formatSeconds,listType,getSubStr } from "@/utils/utils";
import { VerifyList } from "@/assets/server/api";
import Pagination from "../../pc/BlockList/Pagination.vue";
export default {
  props: ["flag"],
  data() {
    return {
      flags: false,
      H: "", 
      H2: "", 
      latestTranstion: [],
      PaginationIndex: 1,
      total: "",
      biaoshi: "",
      Address: [],
      Time: [],
      Top: "",
      left: "",
      LogoImg: require("@/assets/pc/HomeTop/Touxiang.svg"),
    };
  },
  watch: {
    deep: true,
    flag(val) {
      this.flags = val;
      this.VerifyLists();
    },
  },
  components: {
    Pagination,
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.H = document.documentElement.clientHeight + 1 + "px";
      this.H2 = document.documentElement.clientHeight + "px";
    });
  },
  methods: {
    none() {
      this.flags = false;
      this.$emit("none", this.flags);
      this.Move();
    },
    async VerifyLists() {
      var calctimea = new Date(); 
      var strdatea = Math.floor(calctimea.getTime() / 1000); 
      const params = {
        pageNum: this.PaginationIndex,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      let data = await VerifyList(formData);
      this.total=100;
      this.latestTranstion = data.result.gasList;
      this.biaoshi = 1;
      for (let i = 0; i < this.latestTranstion.length; i++) {
        this.Address[i] = getSubStr(this.latestTranstion[i].address,0,6);
        let timestamp = Math.floor(
          this.gltime(this.latestTranstion[i].tradeTime) / 1000
        );
        var s = strdatea - timestamp;
        this.latestTranstion[i].tradeTime = formatSeconds(s);
        if (this.latestTranstion[i].name == "") {
          this.latestTranstion[i].name = "Unknown";
        }
        if (this.latestTranstion[i].logo === "") {
          this.latestTranstion[i].logo = this.LogoImg;
        }
      }
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000; 
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone; 
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
    CurrentChange(e) {
      this.PaginationIndex = e;
    },
    ToAddress(index) {
      this.$router.push({ path: "/pc/BkHash", query: { query: index } });
      this.Move();
    },
    Move() {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "0px";
    },
  },
};
</script>

<style lang="less" scoped>
.VerifyNode1 {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  overflow: auto;
}
.VerifyNode {
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  .VerifyNode_All {   
    width: 947px;
    height: 602px;
    background: #232a35;
    border-radius: 16px 16px 16px 16px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .VerifyNode-Top {
      margin-bottom: 4px;
      padding: 20px 20px 0 20px;
      span {
        display: inline-block;
      }
      span:nth-child(1) {
        margin-right: 696px;
        display: inline-block;
        font-size: 16px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.9);
        line-height: 24px;
      }
      span:nth-child(2) {
        display: inline-block;
        img {
          width: 24px;
          height: 24px;
        }
        cursor: pointer;
      }
    }
    .VerifyNode-center {
     
      height: 46px;
      display: flex;
      background: #2c3645;
      p {
        flex: 1;
        font-size: 14px;
        font-family: SF Pro Text-Regular, SF Pro Text;
        font-weight: 400;
        color: #ffffff;
        line-height: 46px;
      }
      p:nth-child(1) {
        padding-left: 42px;
      }
      p:nth-child(2) {
        text-align: center;
      }
      p:nth-child(3) {
        text-align: center;
      }
    }
    .VerifyNode-List {
       min-height: 464px;
      ul {
        padding-bottom: 24px;
        li {
          display: flex;
          height: 44px;
          padding: 0 0 0 21px;
          p {
            flex: 1;
            font-size: 12px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.9);
            line-height: 44px;
          }
          p:nth-child(1) {
            padding-right: 21px;
            position: relative;
            span {
              display: inline-block;
            }
            span:nth-child(1) {
              position: absolute;
              top: 13px;
              left: 0;
              width: 20px;
              height: 20px;
              border-radius: 50%;
              overflow: hidden;
              img {
                width: 20px;
                height: 20px;
                border-radius: 50%;
              }
            }
            span:nth-child(2) {
              margin-left: 28px;
            }
          }
          p:nth-child(2) {
            span {
              width: 100%;
              display: inline-block;
              font-size: 12px;
              font-family: SF Pro Text-Regular, SF Pro Text;
              font-weight: 400;
              color: #00a870;
              line-height: 44px;
              text-align: center;
              cursor: pointer;
            }
          }
          p:nth-child(3) {
            text-align: center;
          }
        }
      }
    }
  }
}
</style>